import { IEngagementContext, TNotificationOrigin } from '~/domain/OfficeNotification';
import PosthogService from '~/services/posthog/PosthogService';

export interface IOfficeNotificationEndOfDayReviewPayload {
  origin: TNotificationOrigin;
  shiftId: string;
  engagement: IEngagementContext;
}

/**
 * Fires when an office lands on the end-of-day flow from a "Confirm Final
 * Hours Worked" email CTA.
 * Event: dental_portal:office_notification:end_of_day_review
 */
export function fireOfficeNotificationEndOfDayReview(
  payload: IOfficeNotificationEndOfDayReviewPayload,
): void {
  PosthogService.getInstance().track('dental_portal:office_notification:end_of_day_review', {
    origin: payload.origin,
    shift_id: payload.shiftId,
    ...payload.engagement,
  });
}
